const initials = "specialSlot/";

export const UPDATE_SPECIAL_SLOT = `${initials}UPDATE_SPECIAL_SLOT`;